// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IeYpon3DvqQLfGM01lDl{width:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"failedReason": `IeYpon3DvqQLfGM01lDl`
};
export default ___CSS_LOADER_EXPORT___;
